export default __webpack_public_path__ + "locales/de/SendInviteDialog.json?hash=b8c6fc17043a752c1ca80c6efb19b147";